import { MutationTree } from 'vuex';
import { UiState } from '../types';
import Vue from 'vue';

export const mutations: MutationTree<UiState> = {
	/**
	 * Toggle the mobile navigation state
	 *
	 * @param {UiState} state - The current UI state
	 * @param {boolean} isOpen - The new state of the mobile navigation
	 * @return {void}
	 */
	TOGGLE_MOBILE_NAV(state: UiState, isOpen: boolean): void {
		Vue.set(state, 'mobileNavOpen', isOpen);
	},

	/**
	 * Set the desktop navigation expanded state
	 *
	 * @param {UiState} state
	 * @param {boolean} isExpanded
	 * @return {void}
	 */
	SET_DESKTOP_NAV_EXPANDED(state: UiState, isExpanded: boolean): void {
		Vue.set(state, 'desktopNavExpanded', isExpanded);
	}
};